<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2 >Pay Profile</h2>
                </div>
                <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id="64">
                    
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/fiAnbtH16Kw?si=vaIlO3JntZcLPgVv"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                
                    
                </div>
         
                <div class="col-md-12" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="65">

                    <label for="" class="mt-2" >The Pay Profile serves as your
                        payment management
                        hub. It streamlines and simplifies your collection operations while
                        providing diverse solutions for your specific requirements. PayG is always
                        ready to serve its merchants and is dedicated to ensuring the utmost ease
                        and efficiency for our valued merchants, prioritizing a seamless experience
                        that empowers your business operations, so PayG came up with the great idea
                        of “Pay Profile”. Pay profile will surely help all our merchants create
                        their own personalized and customized “Business profile” as it is just like
                        a business webpage. With this new feature, your customers will know more
                        about your business when you share your payment link or QR code with them.
                        It is like a direct connection with your customers as they can know your
                        business thoroughly through your profile. The merchants must provide all
                        relevant business information in their Pay profile so that their customers
                        have the best possibility of learning about them. The Pay profile can be
                        created by the merchants as per their requirements as it is fully
                        customizable and free of cost. Because of compliance and for the benefit of
                        their customers, it is crucial for the merchant to provide all necessary
                        information about their business, including a phone number and email
                        address, so that they may be contacted in the event of an issue. The most
                        important thing about the pay profile is the “Payment form” and it is also
                        fully customizable. The merchant can select either the amount is fixed for
                        all, the customers can choose the amount they want to pay or create a
                        catalog. In the realm of accepting payments from customers, merchants often
                        encounter two distinct scenarios: when the customers are familiar to them,
                        and when they are not. Recognizing this challenge, PayG has introduced a
                        strategic solution in the form of 'Smart Collect' and 'Easy Collect'
                        features. Below is a detailed explanation of the features: </label>
                  

                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id="66">
                    <h2 >Smart collect </h2>
                    <label for="" class="mt-2" >When the customers are known, and
                        their details are
                        available to the merchants then this feature “Smart collect” can be used.
                        For a better understanding let’s take an example from our daily life. For
                        instance, let's consider the government's electricity department. They are
                        responsible for collecting electricity bills from a specific state. All the
                        residents' information in that state is already stored in government
                        records. So, they can simply select and set up a "smart collection profile"
                        within PayG. Now further, the electricity department has two choices of
                        creating bulk links by uploading an Excel file in their “Pay profile” and
                        all the data gets retrieved from there and through the link created, the
                        customers can pay their bills. The second option comes into play when due to
                        some condition, a customer is left behind and unable to access that link and
                        pay the bill so the electricity department can share a common link and by
                        entering details like customer ID, address, etc., the customer can pay the
                        bill. Also in smart collect, the merchant will be aware of how much money
                        will be coming from the customers, so PayG uses a Pie chart in the
                        merchant's Smart collect dashboard. </label>
                                  </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'4')"
                    (mouseout)="showpayment(false,'4')" id="67">
                    <h2 >Easy collect </h2>
                    <label for="" class="mt-2" >
                        This is the feature in which the customers are unknown to the merchants. For
                        example, when we go to a restaurant, we are unknown to the restaurant
                        owner/merchant, and our details are unknown to the merchants we just go and
                        pay, in this case, Easy Collect can be used by the merchants as a single
                        link can be used by multiple customers. Also, for donations Easy Collect is
                        used as the merchant is unaware of the amount as well as the customers. In
                        Easy Collect, merchants can make a catalog as well, if they have different
                        products in their business and the rate list is different for those
                        products. For instance, if the merchant owns an amusement park and they have
                        different zones in their park like kids' zone, adult zone, and eating zone
                        the payment for them is different. So, the merchant can create a catalog in
                        “Easy collect” and can generate a QR code and when the customers scan the QR
                        code, they can choose the option either they want to pay for the kids’ zone,
                        adult zone, the eating zone, or for all. The payment here is prefilled by
                        the merchants while creating the profile.
                    </label>
                
                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'5')"
                    (mouseout)="showpayment(false,'5')" id="68">
                    <h2 >Pay Profile features: </h2>
                    <label for="" class="" >Certainly, here are some key features and
                        benefits of the
                        Pay Profile: </label>
                    <label for="" class="mt-4" ><b>Personalized Business Profile:</b>
                        Pay Profile
                        enables merchants to create their own personalized and customized Business
                        Profile. This provides a platform to showcase important business information
                        and offerings. </label>
                    <label for="" class="mt-4" ><b>Enhanced Customer Insight:</b> By
                        sharing their
                        payment link or QR code through Pay Profile, merchants can provide customers
                        with comprehensive insights into their business. Customers can learn more
                        about the merchant's services, products, contact information, and more.
                    </label>
                    <label for="" class="mt-4" ><b>Streamlined Payment Collection
                        </b> <br>

                        Pay Profile simplifies the payment collection process by offering a
                        user-friendly interface for both merchants and customers. This convenience
                        can lead to increased sales and customer satisfaction. </label>
                    <label for="" class="mt-4" ><b>Professional Appearance </b> <br>

                        The business profile created through Pay Profile adds a professional touch
                        to the merchant's payment collection process, enhancing the trust and
                        credibility of the business. </label>
                    <label for="" class="mt-4" ><b>Marketing and Branding</b> <br>

                        Merchants can leverage their Pay Profile as a marketing tool to promote
                        their brand, products, and services. It provides an additional avenue for
                        brand exposure and customer engagement.</label>
                    <label for="" class="mt-4" ><b>Centralized Payment Management
                        </b> <br>

                        Merchants can manage payment-related activities, including tracking
                        transactions, issuing refunds, and viewing payment history, all from a
                        centralized platform.</label>
                    <label for="" class="mt-4" ><b>Accessibility</b> <br>

                        Pay Profile is accessible to customers through payment links or QR codes,
                        making it convenient for customers to access business information and make
                        payments using their preferred methods. </label>
                    <label for="" class="mt-4" ><b>Scalability</b> <br>

                        Pay Profile can scale with the growth of the merchant's business,
                        accommodating an increasing number of customers and transactions. </label>
                                  </div>
            </div>
        </div>
   </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5 >
                        Table of Contents:
                    </h5>
                  
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#64">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="videoHover"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >What is
                                    PayG’s Pay profile? </span>
                              
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="https://www.youtube.com/embed/smrgAnqUvSo" target="_blank">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="pdfHover"
                                    [ngClass]="{'video':colors=='6'}" (click)="color('6')"
                                    >
                                    Registrations in Hospitality Industry</span>
                               
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="https://www.youtube.com/embed/4o9XW0B-JaY" target="_blank">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="pdfHover"
                                    [ngClass]="{'video':colors=='6'}" (click)="color('6')"
                                    >
                                    Collect Donations with Pay Profile </span>
                               
                            </div>
                        </div>
                    </a>
                </div>
                
                <div class="col-md-12 mt-3">
                    <a href="#65">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                    >What is
                                    PayG’s Pay profile? </span>
                              
                            </div>
                        </div>
                    </a>
                </div>
                
                <div class="col-md-12 mt-3">
                    <a href="#66">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                    >
                                    Smart Collect </span>
                         
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-0">
                    <a href="#67">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                    >Easy
                                    Collect </span>
                        
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-0">
                    <a href="#68">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                                    >Features
                                    of Pay Profile </span>
                             
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/disputes']">  <button class="btn btn-color" (click)="menues('Disputes')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp; Disputes
                </button></a>
                
            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/easy-collect']">   <button class="btn btn-color" (click)="menues('Easy Collect')" > Easy
                    Collect
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
               
            </div>

        </div>
    </div>
    </div>